module.exports = __webpack_public_path__ + "img/cartilha-anunciante.2e3d5ed5.jpg";